import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import localForage from 'localforage'
import datosrciModules from '@/modules/datosrci'
import datosregioModules from '@/modules/datosregio'
import loginModules from '@/modules/login'
import adminModules from '@/modules/admin'
import vendedorModules from '@/modules/vendedor'
import preprensaModules from '@/modules/preprensa'
import ingenieriaModules from '@/modules/ingenieria'
import urlsModules from '@/modules/urls'
import bitacoracd74Modules from '@/modules/access/bitacoracd74'
import bitpegadoraModules from '@/modules/access/bitpegadora'
import bittroqueladora3Modules from '@/modules/access/bittroqueladora3'
import bittroqueladoran1Modules from '@/modules/access/bittroqueladoran1'
import cierreordenfabricacionModules from '@/modules/access/cierreordenfabricacion'
import permisionsModules from '@/modules/permisions'
import rolesModules from '@/modules/roles'
import menusModules from '@/modules/menus'
import comentarioIngModules from '@/modules/comentarioIng'
import ofdatosrciModules from '@/modules/ofdatosrci'
import ofdatosregioModules from '@/modules/ofdatosregio'
import guillotinaModules from '@/modules/access/guillotina'
import bobst106Modules from '@/modules/access/bobst106'
import operadorModules from '@/modules/access/reportes/operador'
import maquinaModules from '@/modules/access/reportes/maquina'
import ordenModules from '@/modules/access/reportes/orden'
import turnoModules from '@/modules/access/reportes/turno'
import filtroofModules from '@/modules/access/maquinas/filtroof'
import ticketModules from '@/modules/ticket'
import etiquetasModules from '@/modules/etiquetas'
import modulosModules from '@/modules/modulos'
import onedriveModules from '@/modules/onedrive'
import imageModules from '@/modules/images'

Vue.use(Vuex)

const vuexLocal = new  VuexPersistence ({
  storage: window.localStorage,
  modules: ['login']
})


export default new Vuex.Store({
  state: { 
    loading: false,
    sidebar: false,
    windowWidth: window.innerWidth
  },
  mutations: {
    setLoading (state,bool){
      state.loading = bool
    },
    setSidebar(state){
      state.sidebar = !state.sidebar
    },
    setWindowWidth(state) {
      state.windowWidth = window.innerWidth;
    }
  },
  actions: {
  },
  modules: {
    datosrci: datosrciModules,
    datosregio: datosregioModules,
    login: loginModules,
    vendedor: vendedorModules,
    admin : adminModules,
    preprensa: preprensaModules,
    ingenieria: ingenieriaModules,
    urls: urlsModules,
    bitacoracd74: bitacoracd74Modules,
    bitpegadora: bitpegadoraModules,
    bittroqueladora3: bittroqueladora3Modules,
    bittroqueladoran1: bittroqueladoran1Modules,
    cierreordenfabricacion: cierreordenfabricacionModules,
    permiso: permisionsModules,
    roles: rolesModules,
    menus: menusModules,
    comentarioIng: comentarioIngModules,
    ofdatosrci: ofdatosrciModules,
    ofdatosregio: ofdatosregioModules,
    guillotina: guillotinaModules,
    bobst106: bobst106Modules,
    operador: operadorModules,
    maquina: maquinaModules,
    orden: ordenModules,
    turno: turnoModules,
    filtroof: filtroofModules,
    ticket: ticketModules,
    etiquetas: etiquetasModules,
    modulos: modulosModules,
    onedrive: onedriveModules,
    images: imageModules,

  },
  plugins: [vuexLocal.plugin]
})
